import { createFileRoute, useParams } from "@tanstack/react-router";
import { queryClient, trpc } from "~/utils/trpc";
import { z } from "zod";
import { CustomDataDetailsDetailsPage } from "../../../-pages/customDataDetailsDetailsPage";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";

const customDataDetailSearchSchema = z.object({
  view: z.enum(["details", "notes", "activity", "documents", "communications", "chat-projects"]).optional().default("details"),
});

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/custom/details/$id/table/$customDetailsId")({
  component: RouteComponent,
  staleTime: 0,
  validateSearch: customDataDetailSearchSchema,
  loader: async ({ params }) => {
    const customData = await queryClient.fetchQuery(
      trpc.customEntities.getCustomEntityDataById.queryOptions({ id: params.customDetailsId }),
    );
    const entity = await queryClient.fetchQuery(
      trpc.customEntities.getCustomEntitiesById.queryOptions({ id: params.id }),
    );

    return { customData, entity };
  },
});

function RouteComponent() {
  const { customData, entity } = Route.useLoaderData();
  const { datasetSlug, id, customDetailsId } = useParams({
    from: "/_dashboard/$datasetSlug/data/custom/details/$id/table/$customDetailsId",
  });
  useBreadCrumbs([
    { title: entity?.name || "Entity", link: `/${datasetSlug}/data/custom/details/${id}/table` },
    { title: "Details", link: `/${datasetSlug}/data/custom/details/${id}/table/${customDetailsId}` },
  ]);
  return <CustomDataDetailsDetailsPage customData={customData} />;
}
